@if (class) {
  <account-page [title]="class.name" [subtitle]="class.description">
    <div class="flex-base">
      <div class="class-info">
        <card-component>
          <card-content>
            <class-info [class]="class"></class-info>
          </card-content>
        </card-component>
      </div>
      @if (permissionService.account && systemConfigService.config.checkoutEnabled) {
        <div class="class-info">
          <card-component>
            <card-content>
              <add-to-cart [class]="class"></add-to-cart>
            </card-content>
          </card-component>
        </div>
      }
    </div>
    @if (showOverflowButton) {
      <div class="flex-base">
        <div class="class-info">
          <raised-button (click)="createWaitingList()" color="primary" [styles]="{ width: '100%' }">Alert me when spaces become available</raised-button>
        </div>
      </div>
    }
  </account-page>
}
